import { createIcon } from '@chakra-ui/react';

export const CloudUpload = createIcon({
  displayName: 'CloudUpload',
  viewBox: '0 0 24 16.046',
  path: (
    <path
      id="Upload_Cloud_-_L-2"
      data-name="Upload Cloud - L"
      d="M15.153,17.889a.571.571,0,0,0,.4-.971l-2.666-2.666h0a.632.632,0,0,0-.187-.122h0a.617.617,0,0,0-.206-.038h0a.575.575,0,0,0-.2.038h0a.545.545,0,0,0-.187.122h0L9.445,16.918a.567.567,0,1,0,.758.8l1.714-1.71v7.864a.571.571,0,0,0,1.143,0V16.015l1.714,1.706a.567.567,0,0,0,.381.168Zm8.028,2.921a4.974,4.974,0,0,0,.129-1.143,5.1,5.1,0,0,0-4.993-5.092A7.895,7.895,0,0,0,3.781,18.51a4.3,4.3,0,0,0,1.009,8.474h6.173a.571.571,0,1,0,0-1.143H5.057a.457.457,0,0,0-.126,0H4.791a3.161,3.161,0,0,1-.381-6.3.571.571,0,0,0,.507-.579v-.141a6.76,6.76,0,0,1,12.606-3.393.575.575,0,0,0,.518.282h.194a3.961,3.961,0,0,1,3.774,5.157.567.567,0,0,0,.24.655,2.335,2.335,0,0,1-1.143,4.319h-7.1a.571.571,0,0,0,0,1.143H21.2a3.469,3.469,0,0,0,1.992-6.166Z"
      transform="translate(-0.485 -10.938)"
      fill="currentColor"
    />
  ),
});
